<div class="potree_container" [ngClass]="{ 'active' : this.potreeCesiumViewerService.viewerIsActive$.getValue() === true }">
  <div #potreeRenderArea id="potree_render_area">
    <div #cesiumContainer class="cesium-container"></div>
  </div>
  <div id="potree_sidebar_container"></div>
</div>